import React from 'react'
import { useStep3Props } from './types'
import { wrap } from '../../../utils/globalUtils'
import useStep3 from './hooks/useStep3'
import Step3View from './views/Step3View'

const Step3: React.FC<useStep3Props> = wrap(Step3View, useStep3)
export default Step3
